import React, { useState, useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, Button } from "reactstrap";

// core components
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Features(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        const hash = props.location.hash.substr(1);

        if (hash && hash != "") {
            document.getElementById(hash).scrollIntoView();
        }
        else {
            document.documentElement.scrollTop = 0;
            document.scrollingElement.scrollTop = 0;
            mainEl.current.scrollTop = 0;
        }

        document.title = "Club Apps | Rich with Features for both Administrators and Members"
        document.querySelector('meta[name="description"]').setAttribute("content", "Our rich set of feature provides a complete tool chest for Administrators and Members. Get started with User Management, Group Management, Membership Levels, Events, Accounting and Notifications.");

    }, []);

    return (
        <Fragment>
            <AppNavbar white />
            <main ref={mainEl}>
                <section>
                    <Container>
                        <Row className="row-grid align-items-center">
                            <Col md="12" className="sub-nav pb-3">
                                <Link className="link text-primary mr-3" to="/overview">
                                    OVERVIEW
                                </Link>
                                <Link className="link text-default mr-3" to="/features">
                                    FEATURES
                                </Link>
                                <Link className="link text-primary" to="/pricing">
                                    PRICING
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section product-features-section">
                    <div className="product-features-background-container"/>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section section-lg  bg-secondary">
                    <Container className="pb-5">
                        <Row className="row-grid justify-content-center">
                            <Col className="text-center" lg="8">
                                <h1 className="display-3">
                                    Our Feature Rich Platform
                                    <span className="text-primary">
                                        Can Meet All Your Needs
                                    </span>
                                </h1>
                                <p className="lead">
                                    Below we go in-depth into the tool chest Club Apps provides. Always feel free to contact our sales team if you have any questions or would like more information!
                                </p>
                                <div className="btn-wrapper">
                                    <Button
                                        className="mb-3 mb-sm-0 mr-2"
                                        color="primary"
                                        href="https://clubapps.org/register"
                                        >
                                        <span className="btn-inner--text">Get Started</span>
                                    </Button>
                                    <Button
                                        className="btn-white mb-3 mb-sm-0"
                                        color="default"
                                        to="/contact/sales"
                                        tag={Link}
                                        >
                                        <span className="btn-inner--text">
                                            Contact Sales
                                        </span>
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="0 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section section-icon-top">
                    <Container className="">
                        <Row className="row-grid justify-content-center">
                            <Col className="text-center" lg="8">
                                <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                                    <i className="ni ni-ui-04" />
                                </div>
                                <h3 className="display-5">
                                    For Administrators
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section section-icon-top-secondary bg-white">
                    <Container className="pb-5">
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Personalized Sub-Domain
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    When you create a new club, you will choose a personalized sub-domain of clubapps.org where you, other administrators, members and guests will be able to access your club. This will be your clubs address so make sure it is memorable.
                                </p>
                            </Col>
                            <Col md="3">
                                <h6>
                                    Ex: <span className="text-success">gryffindor.clubapps.org</span>
                                </h6>
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Personalized Domain
                                </h3>
                                <h6 className="text-organization mb-0">
                                    Organization
                                </h6>
                                <h6 className="text-institution">
                                    Institution
                                </h6>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Sign up for one of our subscription packages to use your own domain to access your club.
                                </p>
                            </Col>
                            <Col md="3">
                                <h6>
                                    Ex: <span className="text-success">www.gryffindor.org</span>
                                </h6>
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    User Management
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our user management feature is the core of our platform and has several helpful tools such as Auto Account Generation (AAG), importing and exporting, bulk actions and more.
                                </p>
                            </Col>
                            <Col md="3">
                                <img
                                    alt="Easy User Import Tool"
                                    className="img-fluid"
                                    src={require("assets/images/user-import.jpg")}
                                />
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Group Management
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our group management feature has two components, membership levels and groups. Membership levels are used to structure your membership because we know here at Club Apps is never as simple as just members. Groups are used for collections of users that don't fit in to the general membership structure but still need to be targeted.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Event Management
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our event management feature is used to create and manage large scale events for your membership. They can target groups or membership levels, issue and allow the purchase of tickets, allow members to invite guests, email invitations and more.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Invoicing
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Keep track of membership dues and ticket sales, or just invoice members directly with the invoicing dashboard. If you choose to connect with stripe, you can moniter your account balances and make transfers from the dashboard as well. Bulk invoice tools allow for administrators to check hundreds of invoices as paid in seconds.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Articles
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Engage with your members by publishing articles about what is happening with your organization.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Documents
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Keep a digital locker of documents accessable to members or just to select membership levels and/or groups.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Analytics
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Monitor how your members are using Club Apps with 30-day, 90-day, or 180-day analytics depending on subscription. Aggregated data will display general usage for different features of the platform. Individual analytics will display how members are using Club Apps and will help administrators answer support requests.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Notifications
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Use notifications to alert members when something happens with the club. Sign up for one of our subscription packages to allow for email and phone notifications using your personalized branding and domain, as well as a local number.
                                </p>
                            </Col>
                            <Col md="3">
                                <div className="icon-preview-container">
                                    <div className="icon icon-with-badge">
                                        <i className="ni ni-bell-55" />
                                        <span className="badge badge-circle badge-inline badge-danger">3</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Proposals
                                </h3>
                                <h6 className="text-organization mb-0">
                                    Organization
                                </h6>
                                <h6 className="text-institution">
                                    Institution
                                </h6>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our powerful proposal system allows administrators to customize every field and detail of how a proposal proccess will work. Everything from recommendations, relation notifications, and more can be added. Use target groups or membership levels to control accessability, while additional tools can use AAG to create profiles of proposed users.
                                </p>
                            </Col>
                            <Col md="3">
                                <p className="text-warning">Currently in Beta</p>
                            </Col>
                        </Row>
                        <hr/>
                        <Row id="dedicated-account-manager" className="row-grid">
                            <Col md="3">
                                <h3 className="heading">
                                    Dedicated Account Manager
                                </h3>
                                <h6 className="text-institution">
                                    Institution
                                </h6>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Sign up for our Institution Subscription and you will be assigned a dedicated account manager capable of handling the administrative work for you. After your initial meeting with your new account manager, they will begin to take support requests, issue notifications, increase member engagement and more depending on your goals.
                                </p>
                            </Col>
                            <Col md="3">
                                <ul>
                                    <li>Handle Support Requests</li>
                                    <li>Manage Invoicing</li>
                                    <li>Create and Manage Events</li>
                                    <li>Publish Articles</li>
                                    <li>Issue Notifications</li>
                                    <li>Monthly Email detailing Analytics</li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <section className="section section-icon-top">
                    <Container className="">
                        <Row className="row-grid justify-content-center">
                            <Col className="text-center" lg="8">
                                <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                                    <i className="ni ni-single-02" />
                                </div>
                                <h3 className="display-5">
                                    For Members and Guests
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section section-icon-top-secondary bg-secondary">
                    <Container className="pb-5">
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    News Feed
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our user dashboard allows members to post topics and comment to the entire Club or to a membership level or group they are apart of. The news feed displays posts, as well as other features like upcoming events and published articles.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Member Directory
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    The directory is where members go to find each other. They can direct their search on various criteria and filter based on publicly tagged groups or membership levels. Users can dictate what information they wish to share on a per club basis in the membership directory within their profile settings.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Events and Tickets
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Members can easily view events and purchase tickets for themselves and/or others depending on event settings.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Guestbook
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Our guestbook feature allows members to create profiles for non-members and quickly invite them to upcoming events.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                        <hr/>
                        <Row className="row-grid">
                            <Col md="3">
                                <h3 className="heading mb-0">
                                    Membership Page
                                </h3>
                            </Col>
                            <Col md="6">
                                <p className="text-muted">
                                    Members can quickly view their current membership status and pay dues using the membership page. Quickly give your members insight on various due dates while delivering a straight forward notice on where they stand available 24/7.
                                </p>
                            </Col>
                            <Col md="3">

                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="0 0 2560 100 0 100"
                                />
                        </svg>
                    </div>
                </section>
                <GetStarted />
            </main>
            <SimpleFooter/>
        </Fragment>
    )
}
